import { markersStore } from 'src/modules/Distances/components/shared/Steps/GPX/stores';

export const removeMarker = (markerArrayIndex: number) => {
  const markers = markersStore.value as any;

  if (markers && markers.length > 0) {
    markers[markerArrayIndex].setMap(null);
  }
};
